<template>
  <div class="chart-component tva-row">
    <div class="title box tva-col-md-offset-3 tva-col-md-6 tva-col-sm-offset-2 tva-col-sm-8 tva-col-xs-12">{{content.title}}</div>
    <div
      class="dida overline tva-col-md-offset-3 tva-col-md-6 tva-col-sm-offset-2 tva-col-sm-8 tva-col-xs-12"
      v-html="content.dida"
    >{{content.dida}}</div>
    <div v-if="content.subtype === 'barchart'" class="bar-chart tva-col-md-offset-2 tva-col-md-8 tva-col-sm-offset-1 tva-col-sm-10 tva-col-xs-12">
      <apexchart
        type="bar"
        height="400"
        :options="barOptions"
        :series="active ? barSeries : resetData(barSeries)"
      />
    </div>
    <div v-if="content.subtype === 'piechart'" class="pie-chart tva-col-md-offset-2 tva-col-md-8 tva-col-sm-offset-1 tva-col-sm-10 tva-col-xs-12">
      <div class="pie-container">
        <h5>1990</h5>
        <apexchart
          type="donut"
          width="300"
          :options="pieOptions"
          :series="active ? pieSeries1 : emptyPieSeries"
        />
      </div>
      <div class="pie-container">
        <h5>2015</h5>
        <apexchart
          type="donut"
          width="300"
          :options="pieOptions"
          :series="active ? pieSeries2 : emptyPieSeries"
        />
      </div>
    </div>
    <div v-if="content.subtype === 'trendline'" class="trendline tva-col-md-offset-2 tva-col-md-8 tva-col-sm-offset-1 tva-col-sm-10 tva-col-xs-12">
      <apexchart
        type="line"
        height="350"
        :options="trendOptions"
        :series="active ? trendSeries : resetData(trendSeries)"
      />
    </div>
    <div class="legend tva-col-md-offset-3 tva-col-md-6 tva-col-sm-offset-1 tva-col-sm-10 tva-col-xs-12">
      <div class="legend-item" v-for="(item, index) in content.legend" :key="index">
        <div class="legend-color" :style="{background: item.color}"></div>
        <div class="overline legend-label">{{item.label}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import _ from "lodash";
export default {
  props: ["content", "active"],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      pieSeries1: [13, 25, 37, 19, 6],
      pieSeries2: [14, 28, 32, 21, 5],
      emptyPieSeries: [100, 0, 0, 0, 0],
      pieOptions: {
        colors: ["#0CC1BC", "#8D4F19", "#C17B37", "#B2491E", "#5F6B6B"],
        legend: {
          show: false
        },
        tooltip: {
          enabled: false
        },
        dataLabels: {
          enabled: true,
          dropShadow: {
            enabled: false
          },
          style: {
            fontSize: "10px",
            fontFamily: "Roboto",
            color: "white"
          }
        },
        chart: {
          stacked: false,
          toolbar: {
            show: false
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
          zoom: {
            enabled: false
          }
        },
        states: {
          hover: {
            filter: {
              type: "none"
            }
          }
        }
      },
      barSeries: [
        {
          name: "rinnovabili",
          data: [1130295, 1227642, 1307487, 1418725, 1628423, 1857300, 1924139]
        },
        {
          name: "CARBONE",
          data: [2220183, 2207026, 2316125, 2993746, 3652298, 3850534, 3730886]
        },
        {
          name: "PETROLIO",
          data: [3233897, 3374906, 3662923, 4000746, 4139699, 4347259, 4390197]
        },
        {
          name: "GAS NATURALE",
          data: [1663518, 1807686, 2072073, 2359231, 2735488, 2943686, 3034954]
        },
        {
          name: "NUCLEARE",
          data: [525520, 608098, 675467, 721706, 718829, 670298, 679649]
        }
      ],
      barOptions: {
        colors: ["#0CC1BC", "#8D4F19", "#C17B37", "#B2491E", "#5F6B6B"],
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        chart: {
          stacked: true,
          toolbar: {
            show: false
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
          zoom: {
            enabled: false
          }
        },
        states: {
          hover: {
            filter: {
              type: "none",
              value: 0
            }
          }
        },
        xaxis: {
          categories: ["1990", "1995", "2000", "2005", "2010", "2015", "2016"],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        fill: {
          opacity: 1
        }
      },
      trendSeries: [
        {
          name: "politiche attuali ",
          data: [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            51,
            52,
            53,
            53,
            54,
            55,
            55,
            56,
            57,
            57,
            58,
            59,
            60,
            60,
            61,
            62,
            62,
            63,
            63,
            64,
            64,
            65,
            65,
            66,
            66,
            67,
            67,
            68,
            68,
            69,
            69,
            69,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            71,
            71,
            71,
            71,
            71,
            71,
            71,
            71,
            71,
            71,
            71,
            71,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            70,
            69,
            69,
            69,
            69,
            68,
            68,
            68,
            68
          ]
        },
        {
          name: "impegni e obiettivi",
          data: [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            51,
            51,
            51,
            51,
            52,
            52,
            52,
            52,
            53,
            53,
            53,
            54,
            54,
            54,
            54,
            54,
            54,
            54,
            54,
            54,
            53,
            53,
            53,
            53,
            53,
            53,
            53,
            53,
            53,
            53,
            52,
            52,
            52,
            52,
            51,
            51,
            51,
            50,
            50,
            49,
            49,
            48,
            48,
            47,
            47,
            46,
            46,
            46,
            45,
            45,
            45,
            44,
            44,
            44,
            43,
            43,
            42,
            42,
            41,
            41,
            40,
            40,
            39,
            39,
            38,
            38,
            37,
            37,
            36,
            36,
            35,
            35,
            34,
            34,
            33,
            33,
            32,
            32,
            31,
            31,
            30,
            30,
            30,
            29
          ]
        },
        {
          name: "limite di 2",
          data: [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            51,
            51,
            52,
            52,
            50,
            48,
            46,
            45,
            43,
            41,
            39,
            37,
            36,
            34,
            33,
            32,
            31,
            30,
            29,
            28,
            26,
            25,
            24,
            23,
            22,
            22,
            21,
            20,
            19,
            18,
            17,
            16,
            15,
            14,
            14,
            13,
            12,
            12,
            11,
            10,
            10,
            9,
            9,
            8,
            8,
            7,
            7,
            7,
            6,
            6,
            6,
            5,
            5,
            5,
            4,
            4,
            4,
            4,
            3,
            3,
            3,
            3,
            2,
            2,
            2,
            1,
            1,
            1,
            0,
            0,
            0,
            -1,
            -1,
            -1,
            -2,
            -2,
            -2,
            -2,
            -2,
            -2,
            -2,
            -2,
            -2,
            -2
          ]
        },
        {
          name: "limite di 1.5",
          data: [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            51,
            51,
            51,
            51,
            49,
            46,
            44,
            41,
            38,
            36,
            33,
            31,
            28,
            25,
            24,
            23,
            22,
            20,
            19,
            18,
            17,
            15,
            14,
            13,
            12,
            12,
            11,
            10,
            10,
            9,
            9,
            8,
            7,
            7,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            4,
            4,
            4,
            3,
            3,
            2,
            2,
            1,
            1,
            0,
            0,
            0,
            -1,
            -1,
            -1,
            -2,
            -2,
            -2,
            -2,
            -2,
            -3,
            -3,
            -3,
            -3,
            -3,
            -3,
            -3,
            -4,
            -4,
            -4,
            -4,
            -4,
            -4,
            -4,
            -5,
            -5,
            -5,
            -5,
            -5,
            -6,
            -6,
            -6,
            -7
          ]
        },
        {
          name: "attuale",
          data: [
            36,
            36,
            36,
            36,
            36,
            37,
            37,
            38,
            38,
            38,
            39,
            40,
            41,
            42,
            43,
            45,
            46,
            47,
            47,
            47,
            49,
            50,
            50,
            51,
            51,
            51,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ]
        }
      ],
      trendOptions: {
        colors: ["#FC7342", "#0CC1BC", "#0A9E97", "#076B63", "#043A35"],
        legend: {
          show: false
        },
        tooltip: {
          enabled: false
        },
        chart: {
          zoom: {
            enabled: false
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: [3, 3, 3, 3, 3],
          curve: "straight"
        },
        xaxis: {
          categories: [
            "1998",
            "2008",
            "2018",
            "2028",
            "2038",
            "2048",
            "2058",
            "2068",
            "2078",
            "2088",
            "2098"
          ],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        }
      }
    };
  },
  methods: {
    resetData(series) {
      var emptyData = _.map(series, object => {
        return {
          name: object.name,
          data: _.map(object.data, item => {
            return (item = 0);
          })
        };
      });
      return emptyData;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";

.chart-component {
  margin-top: 50px;
  .box {
    font-weight: 500;
    position: relative;
    margin-bottom: 5px;
    border-bottom: solid 3px $terna-blu;
    width: fit-content;
  }
  .dida {
    padding: 0 !important;
    margin-bottom: 30px;
  }
  .legend {
    display: flex;
    margin: 0 auto;
    padding: 0 !important;
    margin-top: 10px;
    margin-bottom: 50px;
    .legend-item {
      display: flex;
      align-items: center;
      .legend-color {
        height: 10px;
        width: 10px;
        margin-right: 5px;
      }
      .legend-label {
        margin-right: 10px;
      }
    }
  }
  .pie-chart {
    display: flex;
    justify-content: space-around;
    .pie-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
@media (max-width: 768px) {
  .chart-component {
    .pie-chart {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
    }
    .trendline {
      padding: 0;
    }
    .bar-chart {
      padding: 0;
    }
    .legend {
      flex-direction: column;
      margin-bottom: 50px;
    }
    .dida {
      margin-top: 20px;
    }
  }
}
</style>
